import React from 'react';
import {
  Box, Typography, Paper, Table, TableHead, TableRow,
  TableCell, TableBody, Avatar
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import listings from './staticListings';

export default function ListingsPage() {
  const navigate = useNavigate();

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Available Listings
      </Typography>

      <Paper
        elevation={4}
        sx={{ borderRadius: 3, overflow: 'hidden', p: 2 }}
      >
        <Table sx={{ minWidth: 900 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
              <TableCell></TableCell>
              <TableCell><strong>Unit</strong></TableCell>
              <TableCell><strong>Listed</strong></TableCell>
              <TableCell><strong>Available</strong></TableCell>
              <TableCell><strong>Beds</strong></TableCell>
              <TableCell><strong>Baths</strong></TableCell>
              <TableCell><strong>Size</strong></TableCell>
              <TableCell><strong>Rent</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listings.map(listing => (
              <TableRow
                key={listing.id}
                hover
                sx={{
                  transition: '0.2s',
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: '#f1faff' }
                }}
                onClick={() =>
                  navigate(`/pm/leasing/listings/${listing.id}`, {
                    state: { listing }
                  })
                }
              >
                <TableCell>
                  <Avatar
                    src={listing.thumbnail}
                    variant="rounded"
                    sx={{ width: 64, height: 48 }}
                  />
                </TableCell>
                <TableCell>{listing.unit}</TableCell>
                <TableCell>{listing.listedDate}</TableCell>
                <TableCell>{listing.availableDate}</TableCell>
                <TableCell>{listing.beds}</TableCell>
                <TableCell>{listing.baths}</TableCell>
                <TableCell>{listing.size} sq ft</TableCell>
                <TableCell>${listing.rent}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
